
// ==================== FILE 6: src/pages/FreeListing.tsx ====================
import React from "react";

const FreeListing: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-xl shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Free Listing</h1>
          <p className="text-gray-600">List your business for free!</p>
        </div>
      </div>
    </div>
  );
};

export default FreeListing;
